import { BaseModel } from "sjs-base-model";

export default class PreventiviInScadenzaModel extends BaseModel {
    public readonly idEstimate: number | undefined;
    public readonly idEstimateRequest: number | undefined;
    public readonly customerName: string = "";
    public readonly customerSurname: string = "";
    public readonly expiringDate: string = "";

    constructor(data: Partial<PreventiviInScadenzaModel>) {
        super();

        this.update(data);
    }
}
